import constants from 'constants';
import _ from 'lodash';

const {
  ADD_HOSPITAL_SUGGESTIONS,
  NEW_HOSPITAL_SUGGESTION,
  ADD_COUNTY_SUGGESTIONS,
  ADD_BRANCH_SUGGESTIONS,
  ADD_COUNTRIES_SUGGESTIONS,
  ADD_SPONSOR_SUGGESTIONS,
  ADD_PARTNER_SUGGESTIONS,
  ADD_SPONSOR_USERS_SUGGESTIONS,
} = constants;

const suggestions = (suggestions = {
  hospital: { q: '', values: [] },
  county: { q: '', values: [] },
  branch: { q: '', values: [] },
  country: { q: '', values: [] },
  sponsor: { q: '', values: [] },
  partner: { q: '', values: [] },
  sponsorUsers: { q: '', values: [] },
}, action) => {
  switch (action.type) {
    case ADD_HOSPITAL_SUGGESTIONS:
      return {
        ...suggestions,
        hospital: {
          ...suggestions.hospital,
          q: action.q,
          values: _.uniq([...suggestions.hospital.values, ...action.suggestions], 'title')
        }
      }
    case NEW_HOSPITAL_SUGGESTION:
      return {
        ...suggestions,
        hospital: {
          ...suggestions.hospital,
          q: action.q,
          values: [...suggestions.hospital.values, action.suggestion]
        }
      }
      break;
    case ADD_COUNTY_SUGGESTIONS:
      return {
        ...suggestions,
        county: {
          ...suggestions.county,
          values: action.suggestions
        }
      }
      break;
    case ADD_BRANCH_SUGGESTIONS:
      return {
        ...suggestions,
        branch: {
          ...suggestions.branch,
          values: action.suggestions
        }
      }
      break;
    case ADD_COUNTRIES_SUGGESTIONS:
      return {
        ...suggestions,
        country: {
          ...suggestions.country,
          values: action.suggestions
        }
      }
      break;
    case ADD_SPONSOR_SUGGESTIONS:
      return {
        ...suggestions,
        sponsor: {
          ...suggestions.county,
          values: action.suggestions
        }
      }
      break;
    case ADD_PARTNER_SUGGESTIONS:
      return {
        ...suggestions,
        partner: {
          ...suggestions.county,
          values: action.suggestions
        }
      }
      break;
    case ADD_SPONSOR_USERS_SUGGESTIONS:
      return {
        ...suggestions,
        sponsorUsers: {
          ...suggestions.sponsorUsers,
          values: action.suggestions,
        },
      };
    default:
      return suggestions;
  }
}

export { suggestions };



// WEBPACK FOOTER //
// ./src/reducers/suggestions.js